<script>
    import Button from '../../Button.svelte';
    import {sgettext} from '../../../i18n.js';

    export let keyword;
    export let onSearch = () => {
    };
    export let onClearSearch = () => {
    };
    export let searching = false;
    export let clearing = false;


    async function onKeyUp(event) {
        if (event.key === 'Enter') {
            onSearch(keyword, true);
        }
    }

    function handleSearch() {
        onSearch(keyword);
    }

    async function handleClearSearch() {
        keyword = '';
        onClearSearch();
    }
</script>

<style>
    .wrapper {
        display: flex;
        align-items: center;
    }

    .wrapper :global(.btn) {
        margin-left: 10px;
    }

    .wrapper input[type="text"] {
        height: 38px;
        width: 210px;
    }

    .wrapper label {
        margin-bottom: 0;
        margin-right: 10px;
    }

</style>

<div class="wrapper">
    <input
      class="form-control"
      type="text"
      bind:value={keyword}
      on:keyup={onKeyUp}
      aria-label={sgettext("$$KEYWORD_1$$")}
    />

    <Button name={sgettext('$$SEARCH$$')} sending="{searching}" type="outline-primary" on:click={handleSearch}/>
    <Button name={sgettext('$$CLEAR$$')} sending="{clearing}" type="outline-secondary" on:click={handleClearSearch}/>
</div>
